<template>
  <div
    :style="flexStyle"
    class="TextAndImage"
  >
    <prismic-rich-text
      :field="getPrimaryText"
      class="TextAndImage__paragraph"
    />
    <prismic-image
      :field="getPrimaryImage"
      class="TextAndImage__image"
    />
  </div>
</template>

<script>
  export default {
    name : 'TextAndImage',
    props : {
      content : {
        type : Object,
        default : null
      }
    },
    computed : {
      getPrimaryText() {
        console.log(this.content)
        return this.content.primary.text;
      },
      getPrimaryImage() {
        return this.content.primary.image;
      },
      flexStyle() {
        return { flexDirection: this.content.primary.flip ? 'row' : 'row-reverse' };
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/scss/shared.scss';
  .TextAndImage {
    margin: 10px 0;
    display: flex;
    &__paragraph {
      font-size: 1.6rem;
      width: calc(60% - 15px);
      margin: 15px;
    }
    &__image {
      width: 40%;
      max-width: 500px;
    }
  }
</style>